import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'
import { errorInterceptor } from './errorInterceptors'
import { requestInterceptor } from './requestInterceptors'
import { responseInterceptor } from './responseInterceptors'

const baseURL = import.meta.env.NODE_ENV === 'test' ? import.meta.env.VITE_PROXY_URL : BASE_URL

const commonConfig: AxiosRequestConfig = {
  baseURL: `${baseURL}/vqc`,
  validateStatus: (status: number) => {
    return status >= 200 && status <= 600 // 全部允许, 不会遇到错误就停止
  },
}

export const requestWithVqc = axios.create(commonConfig)

requestWithVqc.interceptors.request.use(requestInterceptor, errorInterceptor)
requestWithVqc.interceptors.response.use(responseInterceptor, errorInterceptor)
